import React, { useContext, useEffect, useState } from "react";
import "./Notification_Offcanvas.css";
import { Offcanvas } from "react-bootstrap";
import { getNotification } from "../../../../utils/apis/notification/notification";
import CustomPaginate from "../../custompaginate/CustomPaginate";
import { Context } from "../../../../utils/context";

const Notification_Offcanvas = (props) => {
  const { signin } = useContext(Context);
  const [notificationData, setNotificationData] = useState({
    data: [],
    current_page: 1,
    total_pages: 1,
  });

  const [currentPage, setCurrentPage] = useState(1);
  const [perPage, setPerPage] = useState(10);

  const getAllNotification = async (name = "", page = 1, perPage = 10) => {
    const res = await getNotification(name, page, perPage);
    if (res?.success) {
      setNotificationData({
        data: res.data.data || [],
        current_page: res.data.current_page || 1,
        total_pages: res.data.total_pages || 1,
      });
    }
  };

  useEffect(() => {
    if (props.show) {
      getAllNotification();
      setCurrentPage(1);
    }
  }, [props.show]);

  useEffect(() => {
    getAllNotification("", currentPage, perPage);
  }, [currentPage, perPage]);

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const getRelativeTime = (dateStr) => {
    if (!dateStr) return "—";
    const date = new Date(dateStr);
    const now = new Date();
    const diffMs = now - date;
    const diffMin = Math.floor(diffMs / 60000);

    if (diffMin < 1) return "just now";
    if (diffMin < 60) return `${diffMin}m ago`;
    if (diffMin < 1440) return `${Math.floor(diffMin / 60)}h ago`;
    return date.toLocaleDateString("en-GB", { day: "numeric", month: "short" });
  };

  return (
    <Offcanvas
      {...props}
      placement="end"
      className="premium-notification-drawer pt-16"
      backdropClassName="notification-backdrop"
    >
      {/* Custom header with highly visible close button */}
      <Offcanvas.Header className="offcanvas-header-modern">
        <Offcanvas.Title className="offcanvas-title">
          Notifications
          {notificationData?.data?.length > 0 && (
            <span className="notification-count">
              ({notificationData.data.length})
            </span>
          )}
        </Offcanvas.Title>

        {/* Custom close button - always visible */}
        <button
          className="custom-close-btn"
          onClick={props.onHide}
          aria-label="Close notifications"
        >
          <svg
            width="28"
            height="28"
            viewBox="0 0 24 24"
            fill="none"
            stroke="#ef4444"
            strokeWidth="3"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <line x1="18" y1="6" x2="6" y2="18" />
            <line x1="6" y1="6" x2="18" y2="18" />
          </svg>
        </button>
      </Offcanvas.Header>

      <Offcanvas.Body className="offcanvas-body-modern">
        {notificationData?.data?.length > 0 ? (
          <>
            <div className="notification-feed">
              {notificationData.data.map((item, index) => (
                <div
                  key={index}
                  className={`notification-card ${!item?.read_at ? "unread" : "read"}`}
                >
                  <div className="notification-content">
                    <h6 className="notification-title">
                      {item?.name || "System Update"}
                    </h6>
                    <p className="notification-message">{item?.remark || "—"}</p>
                  </div>

                  <div className="notification-meta">
                    <span
                      className="notification-time"
                      title={new Date(item?.createdAt).toLocaleString()}
                    >
                      {getRelativeTime(item?.createdAt)}
                    </span>

                    {!item?.read_at && <span className="unread-indicator" />}
                  </div>
                </div>
              ))}
            </div>

            {notificationData.total_pages > 1 && (
              <div className="pagination-container">
                <CustomPaginate
                  currentPage={notificationData.current_page}
                  totalPages={notificationData.total_pages}
                  handlePageChange={handlePageChange}
                />
              </div>
            )}
          </>
        ) : (
          <div className="empty-state">
            <div className="empty-icon">🔔</div>
            <h4 className="empty-title">No Notifications Yet</h4>
            <p className="empty-subtitle">
              We'll let you know when something important happens
            </p>
          </div>
        )}
      </Offcanvas.Body>
    </Offcanvas>
  );
};

export default Notification_Offcanvas;